(() => {
  'use strict';

  const root = document.documentElement;
  const body = document.body;
  const mobileDock = document.querySelector('.mobile-dock');
  const mobileMenu = document.getElementById('kk-mobile-menu');
  const menuOpen = document.querySelector('[data-kk-menu-open]');
  const menuClose = document.querySelector('[data-kk-menu-close]');
  const searchOverlay = document.querySelector('[data-kk-search-overlay]');
  if (searchOverlay) searchOverlay.inert = true;
  const searchInput = searchOverlay?.querySelector('input[type="search"]');
  const searchResults = searchOverlay?.querySelector('[data-kk-search-results]');
  const searchTitle = searchOverlay?.querySelector('[data-kk-search-title]');
  const initialSearchMarkup = searchResults?.innerHTML || '';
  const announcementSlider = document.querySelector('[data-kk-announcement-slider]');
  const announcementSlides = announcementSlider ? [...announcementSlider.querySelectorAll('[data-kk-announcement-slide]')] : [];
  const heroKey = document.querySelector('.hero-key');

  const initHeroVideo = (scope = document) => {
    const wraps = scope.matches?.('.vh-frame-wrap')
      ? [scope]
      : [...(scope.querySelectorAll?.('.vh-frame-wrap') || [])];
    wraps.forEach((wrap) => {
      if (wrap.dataset.kkVideoRevealReady === 'true') return;
      const video = wrap.querySelector('video');
      if (!video) return;
      wrap.dataset.kkVideoRevealReady = 'true';
      const reveal = () => wrap.classList.add('is-ready');
      video.addEventListener('playing', reveal, { once: true });
      if (!video.paused && video.readyState >= 2) reveal();
      const desktop = window.matchMedia('(min-width: 801px)');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const start = () => {
        if (!desktop.matches || motion.matches || navigator.connection?.saveData) {
          video.pause();
          wrap.classList.remove('is-ready');
          return;
        }
        const source = video.querySelector('source[data-src]');
        if (source && !source.hasAttribute('src')) {
          source.src = source.dataset.src;
          video.load();
        }
        video.play().catch(() => {});
      };
      const schedule = () => 'requestIdleCallback' in window
        ? window.requestIdleCallback(start, { timeout: 1500 })
        : window.setTimeout(start, 250);
      if (document.readyState === 'complete') schedule();
      else window.addEventListener('load', schedule, { once: true });
      desktop.addEventListener('change', start);
      motion.addEventListener('change', start);
    });
  };

  const updateScrollState = () => {
    root.classList.toggle('kk-scrolled', window.scrollY > 40);
    if (heroKey) {
      heroKey.classList.toggle('off', window.scrollY > 80);
    }
    if (mobileDock) {
      mobileDock.classList.toggle('kk-visible', window.scrollY > 110);
    }
  };

  const updateOverlayState = () => {
    const cartOpen = Boolean(
      document.querySelector('cart-drawer.active, cart-drawer[open], .cart-drawer.active, .mini-cart.open, .mini-cart.active')
    );
    body.classList.toggle('kk-cart-open', cartOpen);
  };

  window.addEventListener('scroll', updateScrollState, { passive: true });
  document.addEventListener('shopify:section:load', (event) => {
    updateScrollState();
    initHeroVideo(event.target);
  });
  document.addEventListener('cart:open', updateOverlayState);
  document.addEventListener('cart:close', updateOverlayState);
  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('.kk-cart-rec-close');
    if (!closeButton) return;
    const recommendations = closeButton.closest('.kk-cart-recommendations');
    if (recommendations) recommendations.hidden = true;
  });

  const setMenu = (open) => {
    if (!mobileMenu) return;
    mobileMenu.classList.toggle('on', open);
    if (!open && mobileMenu.contains(document.activeElement)) menuOpen?.focus({ preventScroll: true });
    mobileMenu.inert = !open;
    mobileMenu.setAttribute('aria-hidden', String(!open));
    if (menuOpen) menuOpen.setAttribute('aria-expanded', String(open));
    body.classList.toggle('kk-menu-open', open);
  };

  let searchOpener;
  const setSearch = (open) => {
    if (!searchOverlay) return;
    const wasOpen = searchOverlay.classList.contains('on');
    if (open && !wasOpen) searchOpener = document.activeElement;
    searchOverlay.classList.toggle('on', open);
    searchOverlay.setAttribute('aria-hidden', String(!open));
    body.classList.toggle('kk-search-open', open);
    searchOverlay.inert = !open;
    if (open) window.setTimeout(() => searchInput?.focus({preventScroll:true}), 50);
    else if (wasOpen) searchOpener?.focus({preventScroll:true});
  };

  if (announcementSlides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let announcementIndex = 0;
    window.setInterval(() => {
      announcementSlides[announcementIndex].classList.remove('on');
      announcementSlides[announcementIndex].setAttribute('aria-hidden', 'true');
      announcementIndex = (announcementIndex + 1) % announcementSlides.length;
      announcementSlides[announcementIndex].classList.add('on');
      announcementSlides[announcementIndex].setAttribute('aria-hidden', 'false');
    }, 4000);
  }

  const escapeSearchText = (value = '') => String(value).replace(/[&<>"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[character]));
  const formatSearchPrice = (value) => {
    const amount = Number(value);
    return Number.isFinite(amount) ? new Intl.NumberFormat(document.documentElement.lang || 'pl', { style: 'currency', currency: 'PLN' }).format(amount) : '';
  };
  const resetSearchResults = () => {
    if (!searchResults) return;
    searchResults.innerHTML = initialSearchMarkup;
    if (searchTitle) searchTitle.textContent = window.KKText.search_recommended;
    searchResults.setAttribute('aria-busy', 'false');
  };
  const normalizeBundleQuery = (value) => String(value || '').toLocaleLowerCase(document.documentElement.lang || 'pl').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ł/g, 'l');
  let bundleIndexPromise;
  let bundleIndexTime = 0;
  const loadBundleIndex = () => {
    if (bundleIndexPromise && Date.now() - bundleIndexTime < 60000) return bundleIndexPromise;
    bundleIndexTime = Date.now();
    bundleIndexPromise = (async () => {
      const routeRoot = window.Shopify?.routes?.root || '/';
      let next = `${routeRoot}search?view=kk-bundle-index&type=product&q=`;
      const products = [], visited = new Set();
      while (next) {
        const url = new URL(next, window.location.origin);
        if (url.origin !== window.location.origin || visited.has(url.href) || visited.size >= 100) throw new Error('Invalid bundle page');
        // Shopify pagination URLs can omit the alternate view parameter.
        url.searchParams.set('view', 'kk-bundle-index');
        visited.add(url.href);
        const response = await fetch(url.href, { signal: AbortSignal.timeout(12000) });
        if (!response.ok) throw new Error(`Bundle index ${response.status}`);
        const data = await response.json();
        if (!Array.isArray(data.products)) throw new Error('Invalid bundle index');
        products.push(...data.products);
        next = data.next;
      }
      return products.map(product => ({ ...product, componentTerms: (product.components || []).flatMap(component => {
        const title = normalizeBundleQuery(component.title);
        return [title, ...(component.variants || []).map(variant => normalizeBundleQuery(`${component.title} ${variant.title === 'Default Title' ? '' : variant.title} ${variant.sku || ''}`))];
      }) }));
    })().catch(error => { bundleIndexPromise = undefined; throw error; });
    return bundleIndexPromise;
  };
  const renderSearchProduct = (product, bundle = false) => {
    const image = product.featured_image?.url || product.image || '';
    const type = product.type || product.vendor || 'Krakowski Kredens';
    return `<a class="kk-search-result"${bundle ? ' data-kk-bundle-result' : ''} href="${escapeSearchText(product.url)}"><div class="kk-search-result-image">${image ? `<img src="${escapeSearchText(image)}" alt="${escapeSearchText(product.title)}" width="184" height="184" loading="lazy">` : ''}</div><span><small>${escapeSearchText(type)}</small><b>${escapeSearchText(product.title)}</b><strong>${escapeSearchText(product.formatted_price || formatSearchPrice(product.price))}</strong></span></a>`;
  };
  let searchTimer;
  let searchController;
  let searchVersion = 0;
  const updateSearchResults = (query) => {
    if (!searchResults) return;
    const cleanQuery = query.trim();
    const version = ++searchVersion;
    window.clearTimeout(searchTimer);
    searchController?.abort();
    if (!cleanQuery) { resetSearchResults(); return; }
    searchResults.setAttribute('aria-busy', 'true');
    searchTimer = window.setTimeout(() => {
      searchController = new AbortController();
      const controller = searchController;
      const state = { products: [], bundles: [], nativeDone: false, bundleDone: false, nativeError: false, bundleError: false };
      const render = () => {
        if (version !== searchVersion) return;
        const pending = !state.nativeDone || !state.bundleDone;
        const ids = new Set(state.products.map(product => String(product.id)));
        const bundles = state.bundles.filter(product => !ids.has(String(product.id)));
        let markup = state.products.map(product => renderSearchProduct(product)).join('');
        if (bundles.length) markup += `<h3 class="kk-search-bundle-heading">${escapeSearchText(searchOverlay.dataset.bundleHeading)}</h3>` + bundles.map(product => renderSearchProduct(product, true)).join('');
        if (!markup && !pending && !state.nativeError && !state.bundleError) markup = `<div class="kk-search-no-results"><b>${escapeSearchText(window.KKText.search_empty)}</b><span>${escapeSearchText(window.KKText.search_hint)}</span></div>`;
        if (state.nativeError) markup += `<p class="kk-search-partial-error">${escapeSearchText(window.KKText.search_retry)}</p>`;
        if (state.bundleError) markup += `<p class="kk-search-partial-error">${escapeSearchText(searchOverlay.dataset.bundleUnavailable)}</p>`;
        const focusedUrl = searchResults.contains(document.activeElement) ? document.activeElement.closest('a')?.getAttribute('href') : null;
        searchResults.innerHTML = markup;
        if (focusedUrl) [...searchResults.querySelectorAll('a')].find(link => link.getAttribute('href') === focusedUrl)?.focus({ preventScroll: true });
        searchResults.setAttribute('aria-busy', String(pending));
        if (searchTitle) searchTitle.textContent = window.KKText.search_results.replace('__QUERY__', cleanQuery);
      };
      render();
      const routeRoot = window.Shopify?.routes?.root || '/';
      fetch(`${routeRoot}search/suggest.json?q=${encodeURIComponent(cleanQuery)}&resources[type]=product&resources[limit]=10`, { signal: controller.signal })
        .then(response => { if (!response.ok) throw new Error(`Search ${response.status}`); return response.json(); })
        .then(data => { state.products = data.resources?.results?.products || []; })
        .catch(error => { if (error.name !== 'AbortError') state.nativeError = true; })
        .finally(() => { state.nativeDone = true; render(); });
      loadBundleIndex()
        .then(products => {
          const terms = normalizeBundleQuery(cleanQuery).match(/[\p{L}\p{N}]+/gu) || [];
          state.bundles = terms.length ? products.filter(product => product.componentTerms.some(title => terms.every(term => title.includes(term)))) : [];
        })
        .catch(() => { state.bundleError = true; })
        .finally(() => { state.bundleDone = true; render(); });
    }, 250);
  };

  menuOpen?.addEventListener('click', () => setMenu(true));
  menuClose?.addEventListener('click', () => setMenu(false));
  document.querySelectorAll('[data-kk-search-open]').forEach((button) => button.addEventListener('click', () => setSearch(true)));
  document.querySelectorAll('[data-kk-search-close]').forEach((button) => button.addEventListener('click', () => setSearch(false)));
  searchOverlay?.querySelectorAll('[data-kk-search-term]').forEach((button) => button.addEventListener('click', () => {
    if (!searchInput) return;
    searchInput.value = button.dataset.kkSearchTerm;
    updateSearchResults(searchInput.value);
    searchInput.focus();
  }));
  searchInput?.addEventListener('input', () => updateSearchResults(searchInput.value));
  searchOverlay?.querySelector('[data-kk-search-form]')?.addEventListener('submit', (event) => {
    event.preventDefault();
    updateSearchResults(searchInput?.value || '');
    searchInput?.focus({ preventScroll: true });
  });
  searchOverlay?.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab') return;
    const controls = [...searchOverlay.querySelectorAll('a[href],button,input')].filter(node => !node.disabled && node.getClientRects().length);
    const first = controls[0], last = controls.at(-1);
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  });
  const searchEntry = document.querySelector('[data-kk-search-entry]');
  if (searchEntry && searchInput) {
    searchInput.value = searchEntry.dataset.searchTerm || '';
    setSearch(true);
    updateSearchResults(searchInput.value);
  }
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    setMenu(false);
    setSearch(false);
  });

  if (window.matchMedia('(max-width: 768px)').matches) {
    document.querySelectorAll('.kk-footer .f-nav').forEach((item) => item.removeAttribute('open'));
  }

  const instagramWidget = document.querySelector('[data-kk-instagram-widget]');
  if (instagramWidget) {
    const storageKey = 'kk:instagram-widget-dismissed-at';
    const dismissalDuration = 30 * 24 * 60 * 60 * 1000;
    let dismissedAt = 0;
    try {
      dismissedAt = Number(window.localStorage.getItem(storageKey)) || 0;
      if (dismissedAt && Date.now() - dismissedAt >= dismissalDuration) {
        window.localStorage.removeItem(storageKey);
        dismissedAt = 0;
      }
    } catch (error) {
      dismissedAt = 0;
    }
    if (!dismissedAt) {
      instagramWidget.hidden = false;
      requestAnimationFrame(() => instagramWidget.classList.add('is-visible'));
    }
    instagramWidget.querySelector('[data-kk-instagram-dismiss]')?.addEventListener('click', () => {
      try { window.localStorage.setItem(storageKey, String(Date.now())); } catch (error) {}
      instagramWidget.classList.remove('is-visible');
      window.setTimeout(() => { instagramWidget.hidden = true; }, 220);
    });
  }

  const updateLystAccessibility = () => {
    document.querySelectorAll('.lyst__inject-header .lyst__menu_wishlist_item').forEach((link) => {
      link.setAttribute('aria-label', window.KKText.wishlist_go);
    });
    document.querySelectorAll('.lyst__inject-index .lyst__wishlist-index-btn, .lyst__inject-detail .lyst__wishlist-detail-btn').forEach((button) => {
      button.type = 'button';
      button.setAttribute('aria-label', button.classList.contains('active') ? window.KKText.wishlist_remove : window.KKText.wishlist_add);
    });
  };
  let lystUpdateQueued = false;
  const scheduleLystAccessibility = () => {
    if (lystUpdateQueued) return;
    lystUpdateQueued = true;
    requestAnimationFrame(() => {
      lystUpdateQueued = false;
      updateLystAccessibility();
    });
  };
  const lystSelector = '.lyst__wishlist-btn, .lyst__menu_wishlist_item, .lyst__inject-index, .lyst__inject-detail, .lyst__inject-header';
  const observer = new MutationObserver((mutations) => {
    updateOverlayState();
    if (mutations.some((mutation) => {
      if (mutation.type === 'attributes') return mutation.target.matches?.('.lyst__wishlist-btn');
      return [...mutation.addedNodes].some((node) => node.matches?.(lystSelector) || node.querySelector?.(lystSelector));
    })) scheduleLystAccessibility();
  });
  observer.observe(body, { attributes: true, childList: true, subtree: true, attributeFilter: ['class', 'open'] });

  updateLystAccessibility();
  initHeroVideo();
  updateScrollState();
  updateOverlayState();
})();
